import { Box } from '@material-ui/core';
import styled from 'styled-components';

export const SocialMediaInputsContainer = styled(Box)`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;
